module.exports = __webpack_public_path__ + "static/customize-phone-1@2x-3407a706c4b3540a779865abd9442cc8.png";